import React, { Component } from 'react';

class PaymentOptionAssets extends Component {
	constructor(props) {
		super(props);

		this.paymentAssets = this.props.paymentAssets;
		this.moneyBackMessage = this.props.moneyBackMessage;
	}

	render() {
		// If there are no payment assets, return null.
		if (!this.paymentAssets || !this.paymentAssets.length) {
			return null;
		}

		// Separate the payment assets into two arrays, one for images and one for text.
		const paymentOptionAssetsText = [];
		const paymentOptionAssetsImages = [];
		this.paymentAssets.forEach((item) => {
			if (item.name === 'purchaseOrder' || item.name === 'authorizationToInvoice') {
				const hasLabel =
					(item.name === 'purchaseOrder' && this.props.purchaseOrderLabel) ||
					(item.name === 'authorizationToInvoice' && this.props.authorizationToInvoiceLabel);
				if (!hasLabel) return;

				paymentOptionAssetsText.push(item);
			} else {
				paymentOptionAssetsImages.push(item);
			}
		});

		const paymentOptionAssetsImagesElements = paymentOptionAssetsImages.map((item, index) => {
			return (
				<li className="payment-options__list-item" key={index}>
					<img className="payment-options__icon" src={item.assetUrl} alt={item.name} />
				</li>
			);
		});
		const paymentOptionAssetsTextElements = paymentOptionAssetsText.map((item, index) => {
			const paymentOptionText =
				(item.name === 'purchaseOrder' && this.props.purchaseOrderLabel) ||
				(item.name === 'authorizationToInvoice' && this.props.authorizationToInvoiceLabel);
			return (
				<li className="payment-options__list-item" key={index}>
					<div className="payment-options__icon payment-options__icon--text avenir-regular">{paymentOptionText}</div>
				</li>
			);
		});

		return (
			<ul className="payment-options__list no-list" aria-label={Granite.I18n.get('Payment options')}>
				{paymentOptionAssetsImagesElements}
				{paymentOptionAssetsTextElements && paymentOptionAssetsTextElements.length > 0 && (
					<li className="payment-options__list-item">
						<ul className="payment-options__list no-list">{paymentOptionAssetsTextElements}</ul>
					</li>
				)}
			</ul>
		);
	}
}

export default PaymentOptionAssets;
